export const DEVICE_ID_KEY = 'reinz_device_id'

export function getDeviceId(): string | null {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY)
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem(DEVICE_ID_KEY, id)
    }
    return id
  } catch {
    // localStorage blocked (e.g. private browsing) or crypto.randomUUID unavailable —
    // return null rather than "" so it's never mistaken for a real shared device ID.
    return null
  }
}
